import React, { PureComponent } from 'react'
import { css } from 'emotion'
import { PageHeader } from 'components'
import { background } from 'images'

class Container extends PureComponent {
  render() {
    const { children, className } = this.props
    const classNames = css(className, styles.container)
    return (
      <section className={classNames}>
        <PageHeader />
        {children}
      </section>
    )
  }
}

const styles = {
  container: css({
    background: `url(${background}) no-repeat`,
    minHeight: '100vh',
    width: '100%',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
  }),
}

export default Container
